import React, { memo, useCallback } from 'react';
import { isValid, parse } from 'date-fns';
import { isMatch } from 'react-day-picker';
import { Calendar } from '@yme/assets/icons';
import { InputMasked } from '@yme/atoms/input';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { ContainerStyled, IconContainerStyled } from './InputStyled';
import { DEFAULT_DATE_FORMAT } from './constants';
import { getInputMask } from './helpers';
import { DatePickerMode } from './types';
export const Input = memo(({ state, value, placeholder, datepickerMode, disabledDays, isRightToLeft, onTextChange, onDateChange, onIconClick, onBlur, }) => {
    const handleReset = useCallback(() => {
        // TODO: md: try to use null
        onDateChange(undefined);
        onTextChange('');
        onBlur?.(undefined);
    }, [onBlur, onDateChange, onTextChange]);
    const handleInputBlur = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    ({ target: { value } }) => {
        const date = parse(value, DEFAULT_DATE_FORMAT, new Date());
        if (disabledDays && isMatch(date, disabledDays)) {
            handleReset();
            return;
        }
        if (isValid(date)) {
            onDateChange(date);
            onBlur?.(date);
        }
        else {
            handleReset();
        }
    }, [onBlur, onDateChange, handleReset, disabledDays]);
    return (React.createElement(ContainerStyled, null,
        React.createElement(InputMasked, { mask: getInputMask(datepickerMode), state: state, name: "DatePickerInput", placeholder: placeholder, value: value, onAccept: onTextChange, blurHandler: handleInputBlur, isDisabled: datepickerMode === DatePickerMode.RANGE }),
        React.createElement(IconContainerStyled, { isRightToLeft: isRightToLeft },
            React.createElement(SVGIcon, { type: Calendar, onClick: onIconClick }))));
});
Input.displayName = 'DatePicker_Input';
